
@if (tour.currentMessage()) {
  <div class="message-absolute" #messageBox [style]="'top:' + messageBoxTop() + 'px; left:' + messageBoxLeft() + 'px;'">
    @if (position() && referredElement()) {
      @switch (position()) {
        @case ('above') { <div class="arrow below"></div> }
        @case ('below') { <div class="arrow above"></div> }
        @case ('left') { <div class="arrow right"></div> }
        @case ('right') { <div class="arrow left"></div> }
      }
    }
    <div class="message-relative">
      <div class="title">
        <div class="title-text">
          {{(tour.currentMessage()!.title | translate)()}}
        </div>
        <button class="invisible" (click)="tour.skipEntireTour()">
          <ngt-button matIcon="close" shape="square" styling="tertiary" />
        </button>
      </div>
      <div class="body">
        {{(tour.currentMessage()!.text | translate)()}}
      </div>
      <div class="footer">
        <p style="flex-grow: 1">{{('help:currentOfTotal' | translate : {current: tour.currentMessageIndex() + 1, total: tour.messages().length})()}}</p>
        @if (hasBackButton()) {
          <button class="invisible" (click)="tour.previous()">
            <ngt-button styling="stroked" style="color: black;">{{('back' | translate)()}}</ngt-button>
          </button>
        }
        @if (!tour.currentMessage()!.hideNextButton) {
          @if (isLastMessage()) {
            <button class="invisible" (click)="tour.next()">
              <ngt-button styling="primary">{{('help:done' | translate)()}}</ngt-button>
            </button>
          } @else {
            <button class="invisible" (click)="tour.next()">
              <ngt-button styling="primary">{{('next' | translate)()}}</ngt-button>
            </button>
          }
        }
      </div>
    </div>
  </div>
}
